import { useEffect } from 'react';

const useTelegramBackButton = (onBack) => {
  useEffect(() => {
    const tg = window.Telegram?.WebApp;
    if (tg?.BackButton) {
      if (onBack) {
        tg.BackButton.show();
        const handleBack = () => {
          onBack();
        };
        tg.BackButton.onClick(handleBack);

        return () => {
          tg.BackButton.offClick(handleBack);
          tg.BackButton.hide();
        };
      } else {
        tg.BackButton.hide();
      }
    }
  }, [onBack]);

  return !!(window.Telegram?.WebApp?.BackButton && onBack);
};

export default useTelegramBackButton;
